import { Icon } from "@iconify/react";
import clsx from "clsx";

const links = [
  {
    label: "Elevintia on X",
    href: "https://x.com/elevintia",
    icon: "ri:twitter-x-fill",
  },
  {
    label: "Elevintia on LinkedIn",
    href: "https://linkedin.com/company/elevintia",
    icon: "mdi:linkedin",
  },
  {
    label: "Elevintia on YouTube",
    href: "https://youtube.com/@elevintia",
    icon: "mdi:youtube",
  },
];

export default function SocialMedia({ className }: { className?: string }) {
  return (
    <div className={clsx("flex gap-3 text-3xl text-white/70", className)}>
      {links.map((link) => (
        <a
          key={link.href}
          href={link.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={link.label}
          className="transition-colors hover:text-white"
        >
          <Icon icon={link.icon} />
        </a>
      ))}
    </div>
  );
}
